/* eslint-disable camelcase */

const interests_index = process.env.INTERESTS_INDEX ||
  `${process.env.HEROKU_APP_NAME}_interests`;

if (interests_index === "undefined_interests") throw new Error("Need to specify an INTERESTS_INDEX environment variable!");

export default {
  interests_index,
  appsignal_key: process.env.APPSIGNAL_KEY,
  env: process.env.ENVIRONMENT,
  freshchat_client_token: process.env.FRESHCHAT_CLIENT_TOKEN || "",
  hellosign_client_id:
    (typeof window !== "undefined" && window.__HC_CONFIG__?.hellosignClientId) ||
    process.env.HELLOSIGN_CLIENT_ID,
  heroku_slug_commit: process.env.HEROKU_SLUG_COMMIT,
  smartyStreetsKey: process.env.SMARTY_STREETS_KEY,
  whitelabel_server_url: process.env.WHITELABEL_URL,
  idle_logout_wait: process.env.IDLE_LOGOUT_WAIT,
  nonProd: process.env.NON_PROD_BANNER === "true",
};
